import { render, staticRenderFns } from "./MypacksItemBtnGroup.vue?vue&type=template&id=96898c8a&"
import script from "./MypacksItemBtnGroup.vue?vue&type=script&lang=js&"
export * from "./MypacksItemBtnGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports